import { ServiceBase } from '../../../../../../../core/services/ServiceBase'
import Proxy from './proxy'

class Service extends ServiceBase {
  getNominalGDP(params) {
    return this.getData(() => Proxy.getNominalGDP(params))
  }
  getRealGDP(params) {
    return this.getData(() => Proxy.getRealGDP(params))
  }
}

export default new Service()
